"use client"

import FilterRadioGroup from "@modules/common/components/filter-radio-group"

export type SortOptions = "storefront_order" | "price_asc" | "price_desc" | "created_at"

type SortProductsProps = {
  sortBy: SortOptions
  setQueryParam: (name: string, value?: string) => void
  "data-testid"?: string
}

const sortOptions = [
  {
    value: "storefront_order",
    label: "Destacado",
  },
  {
    value: "created_at",
    label: "Nuevo",
  },
  {
    value: "price_asc",
    label: "Precio: de menor a mayor",
  },
  {
    value: "price_desc",
    label: "Precio: de mayor a menor",
  },
]

const SortProducts = ({
  "data-testid": dataTestId,
  sortBy,
  setQueryParam,
}: SortProductsProps) => {
  const handleChange = (value: SortOptions) => {
    setQueryParam("sortBy", value)
  }

  return (
    <FilterRadioGroup
      title="Ordenar"
      items={sortOptions}
      value={sortBy}
      handleChange={handleChange}
      data-testid={dataTestId}
    />
  )
}

export default SortProducts
